@if (payload(); as p) {
  <div class="approval-card">
    <div class="approval-card__header">
      <mat-icon class="approval-card__header-icon">lightbulb</mat-icon>
      <span class="approval-card__title">
        {{ p.card.title || ('GNR_ALLO_PROPOSED_ACTION' | translate) }}
      </span>
    </div>

    @if (p.card.description) {
      <p class="approval-card__description">{{ p.card.description }}</p>
    }

    <div class="approval-card__body">
      @for (field of p.card.editableFields; track field.key) {
        <div class="approval-card__field">
          <label class="approval-card__label" [attr.for]="'apf_' + field.key">
            {{ field.label | translate }}
          </label>
          @switch (field.type) {
            @case ('textarea') {
              <textarea
                [id]="'apf_' + field.key"
                class="approval-card__textarea"
                rows="4"
                [ngModel]="formValues()[field.key] ?? ''"
                (ngModelChange)="updateField(field.key, $event)"
                [disabled]="submitting() || decision() !== null"></textarea>
            }
            @case ('number') {
              <input
                [id]="'apf_' + field.key"
                class="approval-card__input"
                type="number"
                [ngModel]="formValues()[field.key] ?? ''"
                (ngModelChange)="updateField(field.key, $event)"
                [disabled]="submitting() || decision() !== null" />
            }
            @case ('date') {
              <input
                [id]="'apf_' + field.key"
                class="approval-card__input"
                type="date"
                [ngModel]="formValues()[field.key] ?? ''"
                (ngModelChange)="updateField(field.key, $event)"
                [disabled]="submitting() || decision() !== null" />
            }
            @case ('select') {
              <select
                [id]="'apf_' + field.key"
                class="approval-card__select"
                [ngModel]="formValues()[field.key] ?? ''"
                (ngModelChange)="updateField(field.key, $event)"
                [disabled]="submitting() || decision() !== null">
                <option value=""></option>
                @for (opt of field.options; track opt.value) {
                  <option [value]="opt.value">
                    {{ opt.label | translate }}
                  </option>
                }
              </select>
            }
            @default {
              <input
                [id]="'apf_' + field.key"
                class="approval-card__input"
                type="text"
                [ngModel]="formValues()[field.key] ?? ''"
                (ngModelChange)="updateField(field.key, $event)"
                [disabled]="submitting() || decision() !== null" />
            }
          }
        </div>
      }
    </div>

    @if (error()) {
      <div class="approval-card__status approval-card__status--error">
        {{ error() | translate }}
      </div>
    }

    @if (decision() === 'approved') {
      <div class="approval-card__status approval-card__status--ok">
        <mat-icon class="approval-card__status-icon">check_circle</mat-icon>
        {{ 'GNR_ALLO_APPROVED' | translate }}
      </div>
    } @else if (decision() === 'rejected') {
      <div class="approval-card__status approval-card__status--rejected">
        <mat-icon class="approval-card__status-icon">cancel</mat-icon>
        {{ 'GNR_ALLO_REJECTED' | translate }}
      </div>
    } @else {
      <div class="approval-card__actions">
        <button
          type="button"
          class="approval-card__button approval-card__button--reject"
          [disabled]="submitting()"
          (click)="reject()">
          {{ 'GNR_REJECT' | translate }}
        </button>
        <button
          type="button"
          class="approval-card__button approval-card__button--accept"
          [disabled]="submitting()"
          (click)="accept()">
          @if (submitting()) {
            <mat-spinner diameter="16" />
          }
          {{
            (submitting()
              ? 'GNR_ALLO_SUBMITTING'
              : p.card.button || 'GNR_ACCEPT'
            ) | translate
          }}
        </button>
      </div>
    }
  </div>
}
